import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output
} from '@angular/core';
import {INavigationItems, INavigationMenuAllTypes, INavigationType} from "../../../navigation.interface";
import {NavigationService} from "../../../navigation.service";
import {ActivatedRoute} from "@angular/router";
import {FormControl} from "@angular/forms";
import {NavigationInteractionsService} from "../../../navigation-interactions.service";

@Component({
    selector: 'db-ecommerce-menu-sidebar',
    templateUrl: './ecommerce-menu-sidebar.component.html',
    styleUrls: ['./ecommerce-menu-sidebar.component.scss'],
    standalone: false
})
export class EcommerceMenuSidebarComponent implements OnInit {
  @Output() closeSidebar: EventEmitter<void> = new EventEmitter<void>();
  showCreateCustom = false;
  types: INavigationType[] = [];
  allTypeItems: INavigationItems;
  website = this._activatedRoute.snapshot.parent.parent.data['website'];
  searchForm = new FormControl(null);

  @HostListener('document:click', ['$event'])
  clickOut(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.closeSidebar.emit();
      this.showCreateCustom = false;
    }
  }

  constructor(private eRef: ElementRef,
              private _activatedRoute: ActivatedRoute,
              private _navigationInteractionsService: NavigationInteractionsService,
              private _navigationService: NavigationService) {
  }

  ngOnInit() {
    this._getMenuItems();
  }

  private _getMenuItems() {
    this._navigationService.getMenuItems(this.website.id)
      .subscribe(response => {
        if (response && response.success) {
          const data = response.data as INavigationMenuAllTypes;
          this.types = data.types;
          this.allTypeItems = data.items;
          this._navigationInteractionsService.allTypeItems.next(this.allTypeItems);
        }
      });
  }

  addNewMenuItem(navigationItem: INavigationType) {
    const navigationTypes = this._navigationInteractionsService.navigationItems.getValue();
    const a: any = {};
    a.title = navigationItem.title;
    a.children = [];
    a.object_type = navigationItem.object_type;
    a.object_id = navigationItem.object_id;
    a.temp_id = new Date().getTime();
    if (Object(navigationItem).hasOwnProperty('url')) {
      a.url = navigationItem.url;
    }
    this._navigationInteractionsService.hasChanges.next(true);
    this._navigationInteractionsService.navigationItems.next([...navigationTypes, a]);
  }

}
